const src = (f) => `/screens/${f}.webp`;

export const SCREENS = [
  {
    id: "login",
    img: src("01-login"),
    label: "Sign in",
    title: "Secure, private sign-in",
    body: "Every session begins at a calm, private sign-in screen that carries the app's own promise: \u201cFaithful stewardship, carefully recorded.\u201d",
    points: ["A private login for your church's books", "A quiet, focused start to every session"],
  },
  {
    id: "dashboard",
    img: src("02-dashboard"),
    label: "Dashboard",
    title: "See everything at a glance",
    body: "The dashboard brings together your total across all accounts, a card for each bank account, fund balances with nested funds rolling up, and recent activity.",
    points: ["Total across all accounts", "A card for every bank account", "Nested funds that roll up", "Recent activity"],
    tall: true,
  },
  {
    id: "transactions",
    img: src("03-transactions"),
    label: "Transactions",
    title: "Track every entry",
    body: "A full transactions ledger with search, filters and cleared checkboxes. Income, expense and transfer rows sit side by side, so nothing goes unrecorded.",
    points: ["Search and filters", "Cleared checkboxes", "Income, expense and transfer rows"],
    tall: true,
  },
  {
    id: "reconciliation",
    img: src("04-reconciliation"),
    label: "Reconciliation",
    title: "Bank reconciliation made simple",
    body: "Filter the ledger to a single account and the Reconciliation bar compares your cleared balance with your bank statement. Reconciliation is done by hand: you mark each entry as cleared against the statement, so every match is one your team has checked.",
    points: ["Filter to one account", "Cleared balance vs. statement", "Reconciled by your team, not synced from the bank"],
    tall: true,
  },
  {
    id: "record",
    img: src("05-record-transaction"),
    label: "Record",
    title: "Record income & expenses in seconds",
    body: "One Record-a-Transaction dialog handles all three kinds of entry, so the Sunday count and the Monday bills follow the same simple path.",
    points: ["Income", "Expense", "Transfer"],
  },
  {
    id: "split",
    img: src("06-split-across-funds"),
    label: "Split gifts",
    title: "Split a single gift across funds",
    body: "Divide one deposit across several funds. A live \u201cFully allocated\u201d helper confirms every dollar has been given a home.",
    points: ["One deposit, many funds", "Live \u201cFully allocated\u201d helper"],
  },
  {
    id: "funds",
    img: src("07-funds"),
    label: "Funds",
    title: "Fund accounting that matches reality",
    body: "The Funds page shows nested fund balances, where a parent fund rolls up its children, alongside a Fund Activity history of moves and adjustments.",
    points: ["Parent funds roll up children", "Fund Activity history"],
  },
  {
    id: "fund-activity",
    img: src("08-fund-activity"),
    label: "Fund moves",
    title: "Reallocate money between funds",
    body: "Move money between funds, or adjust a fund, without touching any bank balance.",
    points: ["Move between funds", "Adjust a fund", "Bank balances untouched"],
  },
  {
    id: "report",
    img: src("09-treasurers-report"),
    label: "Treasurer's Report",
    title: "Board-ready reports, every month",
    body: "The printable monthly Treasurer's Report sets out per-account income and expense detail, a category summary and fund balances. Print it, or download it as a PDF.",
    points: ["Per-account income & expense detail", "Category summary", "Fund balances", "Print or download as PDF"],
    tall: true,
  },
  {
    id: "accounts",
    img: src("10-settings-accounts"),
    label: "Bank accounts",
    title: "Set up your accounts",
    body: "Manage your church's bank accounts from Settings \u2192 Bank Accounts.",
    points: ["All bank accounts in one place"],
  },
  {
    id: "settings-funds",
    img: src("11-settings-funds"),
    label: "Fund settings",
    title: "Flexible, nestable funds",
    body: "Settings \u2192 Funds is where you set opening balances and nest funds beneath one another, such as a fund placed under the General Fund.",
    points: ["Opening balances", "Funds nested under a parent"],
  },
  {
    id: "backup",
    img: src("12-settings-backup"),
    label: "Backup & Restore",
    title: "Your data, safe and yours",
    body: "Backup & Restore offers manual export and restore, automatic nightly backups and optional email backups, whether you host Grace Treasury yourself or have it hosted for you.",
    points: ["Manual export & restore", "Automatic nightly backups", "Optional email backups", "Self-hosted or hosted for you"],
    tall: true,
  },
  {
    id: "import",
    img: src("13-import-csv"),
    label: "CSV import",
    title: "Bring your history with you",
    body: "A CSV import dialog bulk-loads past months, so your records are complete from the first day.",
    points: ["Bulk-load past months from CSV"],
    download: { href: "/transaction-import-template.csv", label: "Download the CSV template" },
  },
];

export const screen = (id) => SCREENS.find((s) => s.id === id);

export const roman = (n) =>
  ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII", "XIII"][n - 1];
